import { useReducer } from "react";
import moment from "moment";

// Simulate an 'enum'
const filterType: Readonly<{ amount: number; speed: number }> = Object.freeze({
  amount: 0,
  speed: 1,
});

// Simulate an 'enum'
const tripType: Readonly<{ all: number; service: number; booking: number; official: number }> = Object.freeze({
  all: 0,
  service: 1,
  booking: 2,
  official: 3,
});

const dateInit: () => { from: Date; to: Date } = (): { from: Date; to: Date } => {
  const now = new Date();
  const to: Date = moment(now).endOf("day").toDate();
  const from: Date = moment(now).subtract(30, 'days').toDate()
  return { from, to };
};

const filterInit: () => {
  filter_type: number;
  dateDisabled: boolean;
  from: Date;
  to: Date;
  timeDisabled: boolean;
  distanceDisabled: boolean;
  distance: any|null;
  distance_type: string;
  deviceId: string|number|null;
  trip_type: number;
  amountOfRoutes: number|null;
  maxSpeed: any|null
} = (): {
  filter_type: number;
  dateDisabled: boolean;
  from: Date;
  to: Date;
  timeDisabled: boolean;
  distanceDisabled: boolean;
  distance: any|null;
  distance_type: string;
  deviceId: string|number|null;
  trip_type: number;
  amountOfRoutes: number|null;
  maxSpeed: any|null
} => ({
  filter_type: filterType.amount,
  dateDisabled: false,
  ...dateInit(),
  timeDisabled: true,
  distanceDisabled: false,
  distance: null,
  distance_type: "km",
  deviceId: null,
  trip_type: tripType.all,
  amountOfRoutes: null,
  maxSpeed: null,
});

const filterClass: string[] = Object.keys(filterInit());

const filterReducer: (state: any, action: any) => (any) = (state:any , action: any): any => {
  const keyIsAvailable = Object.keys(action).indexOf("key") > -1;
  if (keyIsAvailable && filterClass.indexOf(action.key) === -1) {
    throw new Error(`Invalid key in action: ${action}`);
  }
  if (action.type !== "RESET" && !keyIsAvailable) {
    throw new Error(`Missing key for action: ${action}`);
  }
  console.log("New action:", action);
  const key = action.key;
  switch (action.type) {
    case "SET":
      return state[key] === action.value
        ? state
        : { ...state, [key]: action.value };
    case "RESET": {
      const def: {
        [key: string]: any
      } = filterInit();
      return keyIsAvailable ? { ...state, [key]: def[key] } : def;
    }
    default:
      throw new Error(`Unknown action: ${action}`);
  }
};

export default () => {
  return useReducer(filterReducer, 0, filterInit);
};
